import { Locale } from "modules/i18n/locale-config";
import { extendTranslation } from "../../../brand-utils";
import defaultTranslation from "../../default/messages/en";

export default extendTranslation(defaultTranslation, {
  locale: Locale.EN.code,
  messages: {
    "root.title": "<b>PREHAB</b> & HEALTH",
    "root.desc": `Welcome to start your journey to a stronger body. <br/>It starts with a <b>Self-assessment</b> (takes a few min.).`,
    "locale-switcher.title": "Language"
  }
});



// WEBPACK FOOTER //
// ./src/modules/brand/brands/actiway/messages/en.js